import React from 'react'
import { shortenNumber } from '../../../../utils/format';
import { Popup } from 'semantic-ui-react';
import { topOfZoneLineYOffset,
        topOfZoneLineXOffset} from '../../../../utils/constants';
import "./BarChart.css"

export const 
TopOfZone = ( dataTopZone ) => {
    const { drawData, shortNumberLength, topOfZoneTextXCoordinate } = dataTopZone
    const { relativeOffset, topOf, topOfFull, width, x, y } = drawData
    const topZoneValueSplit = topOf.split(": ")

    const renderGContainer = ( TopOfZoneValue )=> {
      return(
        <g>
          <line
            className={"topOfZoneLine"}
            x1={x + width}
            y1={y + topOfZoneLineYOffset}
            x2={topOfZoneTextXCoordinate - topOfZoneLineXOffset}
            y2={y + topOfZoneLineYOffset + relativeOffset}
          />
          <text
            x={topOfZoneTextXCoordinate}
            y={y + 5 + relativeOffset}
            z={1}
            className={"topOfZone"}
          >
            { TopOfZoneValue }
          </text>
        </g>
      )
    }

    return(
      <Popup
        on='hover'
        position="right center"
        trigger={renderGContainer(topZoneValueSplit[0] + ': ' + shortenNumber(topZoneValueSplit[1].trim(), shortNumberLength+0.5))}
      >
        <Popup.Header> {topOfFull} </Popup.Header>
        <Popup.Content className="chart-popup-content">{topZoneValueSplit[1].trim()}</Popup.Content>
      </Popup>
    )
  };